import { request } from '@api/request'
import {
  FuelModelDTO,
  IdentifiedFuelModelDTO
} from '@models/api/simulation/FuelModelDTO'

export const fuelModelFile = {
  getFuelModelFileFromOrg: function () {
    return request.get<IdentifiedFuelModelDTO[]>(
      'simulation/getFuelModelFileFromOrg'
    )
  },
  insertFuelModelFileForOrg: function (fuelModel: FuelModelDTO) {
    return request.post('simulation/insertFuelModelFileForOrg', fuelModel)
  },
  updateFuelModelFile: function (fuelModel: IdentifiedFuelModelDTO) {
    return request.put('simulation/updateFuelModelFile', fuelModel)
  },
  deleteFuelModelFile: function (
    fuelModelID: IdentifiedFuelModelDTO['ID_FUEL_MODEL_FILE']
  ) {
    return request.delete('simulation/deleteFuelModelFile', {
      data: {
        ID_FUEL_MODEL_FILE: fuelModelID
      }
    })
  },

  getDefaultPreset: function () {
    return request.get<[IdentifiedFuelModelDTO]>(
      'simulation/getOrganizationPreset'
    )
  },
  setDefaultPreset: function (
    fuelModelID: IdentifiedFuelModelDTO['ID_FUEL_MODEL_FILE']
  ) {
    return request.put('simulation/updateOrganizationPreset', {
      ID_FUEL_MODEL_FILE: fuelModelID
    })
  }
}
